<template>
    <el-row class="grid-stack-item">
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <div class="header">
                <h1>{{ $t('Account Settings') }}</h1>
            </div>
            <div class="my-content">
                <div class="grid-stack-item-content">
                    <el-form label-position="top" :model="formData" ref="formData" class="demo-dynamic" :rules="rules">
                        <el-row :gutter="20">
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-form-item :label="$t('Area document no.')" prop="area_document_number">
                                    <el-input v-model="formData.area_document_number"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                <el-form-item :label="$t('Start date')" prop="start_date">
                                    <el-date-picker :picker-options="{disabledDate(date) { return (formData.end_date && date > new Date(formData.end_date));}}" style="width:100%;" v-model="formData.start_date" type="date" :placeholder="$t('Start date')" format="dd-MM-yyyy" value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                <el-form-item :label="$t('End date')" prop="end_date">
                                    <el-date-picker :picker-options="{disabledDate(date) {return (formData.start_date && date < new Date(formData.start_date));}}" style="width:100%;" v-model="formData.end_date" type="date" :placeholder="$t('End date')" format="dd-MM-yyyy" value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-form-item :label="$t('Currency')" prop="currency_code">
                                    <el-select v-model="formData.currency_code" :placeholder="$t('Select currency')">
                                        <el-option v-for="currency in getCurrencyList" :key="currency" :label="currency" :value="currency"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :lg="24">
                                <el-form-item>
                                    <el-button type="primary" @click="submitForm('formData')" size="medium">{{ $t('Update') }}</el-button>
                                    <el-button type="cancel" @click="closeBookingDialog = !closeBookingDialog" size="medium">{{ $t('Close booking year') }}</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <account-freeze :acc-settings="formData" :closeBookingDialog="closeBookingDialog" @popup="value => { this.closeBookingDialog = value }"/>
                </div>
            </div>
        </el-col>
    </el-row>
</template>

<script>
import AccountFreeze from './AccountFreeze'
    export default {
        components: {
            AccountFreeze
        },
        data() {
            return {
                formData: {},
                closeBookingDialog: false,
                rules: {
                    'area_document_number': [{
                        required: true,
                        message: this.$t('This field is required')
                    }],
                    'start_date': [{
                        required: true,
                        message: this.$t('This field is required')
                    }],
                    'end_date': [{
                        required: true,
                        message: this.$t('This field is required')
                    }],
                    'currency_code': [{
                        required: true,
                        message: this.$t('This field is required')
                    }]
                },
                getCurrencyList: process.env.KIPAKI_currency_list
            };
        },
        mounted() {
            this.getSettings();
        },
        methods: {
            getSettings() {
                request({
                    url: "account-settings",
                    method: "get",
                    params: {}
                }).then(response => {
                    this.formData = response.data.data;
                });
            },
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        request({
                                url: "account-settings/"+this.formData.id,
                                method: "PATCH",
                                data: this.formData
                            })
                            .then(response => {
                                this.$notify({
                                    title: this.$t('Success'),
                                    message: response.data.message,
                                    type: "success",
                                    offset: 50
                                });
                            })
                            .catch(error => {
                                this.$notify({
                                    title: this.$t('Error'),
                                    message: error.response.data.message,
                                    type: "error",
                                    offset: 50
                                });
                            });
                    }
                });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/Layout/Accounts/AccountSettings.vue